import React, {useEffect, useState} from 'react';
import {useTriggers} from './hooks/useTriggers';
import TriggerList from './components/TriggerList';
import TriggerModal from './components/TriggerModal';
import TriggerForm from './components/TriggerForm';
import {createTriggerApi, updateTriggerApi} from './api/triggersApi';
import {Button, Typography} from "@mui/material";
import {getClinic} from "../../http/clinicAPI";

export default function AutoTriggersPage() {
    const {triggers, loading, error, reload} = useTriggers();
    const [modalVisible, setModalVisible] = useState(false);
    const [editingTrigger, setEditingTrigger] = useState(null);
    const [clinic, setClinic] = useState(null);


    useEffect(() => {
        fetchClinic();
    }, []);

    async function fetchClinic() {
        const clinic = await getClinic();
        setClinic(clinic);
    }

    function openModal(trigger = null) {
        setEditingTrigger(trigger);
        setModalVisible(true);
    }

    function closeModal() {
        setModalVisible(false);
        setEditingTrigger(null);
    }

    async function handleSave(dto, image) {
        try {
            const formData = new FormData();

            Object.entries(dto).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    if (key === 'params') {
                        formData.append(key, JSON.stringify(value));
                    } else {
                        formData.append(key, value);
                    }
                }
            });

            if (image) {
                formData.append('image', image);
            }

            if (editingTrigger && editingTrigger.id) {
                await updateTriggerApi(editingTrigger.id, formData);
            } else {
                await createTriggerApi(formData);
            }

            await reload();
            closeModal();
        } catch (e) {
            alert('Ошибка сохранения: ' + e.message);
        }
    }


    return (
        <div style={{padding: 20}}>
            <Typography variant='h4' component="h4" sx={{m: 0, mb: 2}}>
                Триггерные рассылки
            </Typography>
            <Button variant='outlined' component='label' sx={{mb: 3}} onClick={() => openModal(null)}>
                Создать триггерную рассылку
            </Button>

            {loading && <p>Загрузка...</p>}
            {error && <p style={{color: 'red'}}>{error}</p>}

            <TriggerList triggers={triggers} clinic={clinic} onEdit={openModal} reload={reload}/>

            <TriggerModal visible={modalVisible} onClose={closeModal}>
                <TriggerForm
                    clinic={clinic}
                    trigger={editingTrigger}
                    onSave={handleSave}
                    onCancel={closeModal}
                />
            </TriggerModal>


        </div>
    );
}
